import * as actions from './actions';
import { NAME } from './constants';
import reducer from './reducer';
import * as selectors from './selectors';

export default {
    actions,
    NAME,
    reducer,
    selectors,
};
